jQuery(document).ready(function($) {
	/**
	 * Product Colors
	 */
	$(".woocommerce-product-gallery__image").each(function() {
		let a = $(this).find('a');
		let img = $(this).find('img');
		a.attr('srcset', img.attr('srcset'));
	})
	let $image = null;
	let $image_org = $('.woocommerce-product-gallery__image.flex-active-slide img');
	let image_src = $image_org.attr('src');
	let image_srcset = $image_org.attr('srcset');
	const $color_buttons = $('.m-woocommerce-product-single-colors-list-item-button');
	$color_buttons.hover(function() {
		$image_org = $('.woocommerce-product-gallery__image.flex-active-slide img');
		image_src = $image_org.attr('src');
		image_srcset = $image_org.attr('srcset');

		const $this = $(this);
		const color_image_src = $this.data('image');
		const color_image_srcset = $this.data('image-srcset');

		if (color_image_src.length) {
			$image = $('.woocommerce-product-gallery__image.flex-active-slide img');
			$image.attr('src', color_image_src);
			$image.attr('srcset', color_image_srcset);
		}
	}, function() {
		// $image = $('.woocommerce-product-gallery__image.flex-active-slide img');
		// $image.attr('src', image_src);
		// $image.attr('srcset', image_srcset);
	});

	$(".m-woocommerce-product-single-colors-list").hover(function() {}, function() {
		$image = $('.woocommerce-product-gallery__image.flex-active-slide img');
		$image.attr('src', $('.woocommerce-product-gallery__image.flex-active-slide > a').attr('href'));
		$image.attr('srcset', $('.woocommerce-product-gallery__image.flex-active-slide > a').attr('srcset'));
	});

	/**
	 * Product Accessories
	 */
	const $accessories = $('.m-woocommerce-product-single-accessories-list-item');
	if ($accessories.length >= 5) {
		let countHideItems = 0;

		$accessories.each(function(index, el) {
			if (index > 4) {
			 	$(el).addClass('hidden').hide();

			 	countHideItems++;
			}
		});

		if (countHideItems > 0) {
			const buttonClass = 'm-woocommerce-product-single-accessories-list-item-button';
			const button_html = `
				<li class="m-woocommerce-product-single-accessories-list-item col-xs-12 col-md-4">
					<button class="${buttonClass}" type="button">
						<span class="count">
							+${countHideItems}
						</span>

						<span class="more">
							${merchupWooCommerce.product.accessories.button.show_more}
						</span>
					</button>
				</li>
			`;
			$accessories.parent().append(button_html);

			$(document).on('click', `.${buttonClass}`, function(event) {
				const $button = $(this);
				$('.m-woocommerce-product-single-accessories-list-item.hidden').removeClass('hidden').slideDown();

				$button.remove();

				event.preventDefault();
			});
		}
	}

	/**
	 * vars.
	 *
	 * @version 3.2.0
	 * @since   1.3.0
	 */
	const options = alg_wc_wh_pr_pbqd_obj;
	if (options) {
		let input_timer;
		const input_timer_interval_ms = options.interval_ms;
		const $price_identifier = options.price_identifier;
		const ppq_element_id   = 'p.alg-wc-wholesale-pricing-price-display-by-qty';
		const ppq_element_html = '<p class="alg-wc-wholesale-pricing-price-display-by-qty"></p>';

		/**
		 * insert_element.
		 *
		 * @version 3.2.0
		 * @since   1.3.0
		 */
		function insert_element() {
			switch ( options.position ) {
				case 'before':
					$( $price_identifier ).before( ppq_element_html );
					break;
				case 'after':
					$( $price_identifier ).after( ppq_element_html );
					break;
			}
		}
	}

	/**
	 * display.
	 *
	 * @version 3.2.0
	 * @since   1.3.0
	 */
	function display( qty ) {
		const $price_identifier = options.price_identifier;
		if ( 'undefined' === typeof qty || null === qty ) {
			return;
		}

		if ( 'grouped' === options.product_type ) {
			return;
		}

		var product_id = ( 'variable' === options.product_type ? $( 'input[name="variation_id"]' ).val() : options.product_id );
		var data = {
			'action'                      : 'alg_wc_wholesale_pricing_price_by_qty_display',
			'alg_wc_wholesale_pricing_qty': qty,
			'alg_wc_wholesale_pricing_id' : product_id,
		};

		$.ajax( {
			type   : 'POST',
			url    : options.ajax_url,
			data   : data,
			success: function ( response ) {
				if ( '' != response ) {
					if ( 'instead' == options.position ) {
						$( $price_identifier ).html( response );
					} else {
						if ( ! $( ppq_element_id ).length ) {
							insert_element();
						}
						$( ppq_element_id ).html( response );
					}
				}
			},
		} );

	}

	/**
	 * run.
	 *
	 * @version 3.2.1
	 * @since   1.3.0
	 *
	 * @todo    [next] [!] (dev) Variation hide: before/after: hide instead of setting it to empty string?
	 * @todo    [next] [!] (dev) use `$( this )` (instead of `$( '[name="' + element_name + '"]' )`) where possible?
	 * @todo    [next] find better solution for `do_force_standard_qty_input`
	 * @todo    [maybe] customizable quantity events: `cut copy paste keyup keydown`
	 * @todo    [maybe] customizable elements (e.g., `quantity_pq_dropdown`)
	 * @todo    [maybe] `setInterval( display_all, 1000 );`
	 * @todo    [maybe] (dev) Update on init: `$( selector ).each( function () { display( $( this ).val() ); } );`
	 */
	function run() {
		// Insert element
		if ( 'instead' != options.position ) {
			insert_element();
		}

		// Vars
		const is_pq_dropdown = ( ! options.do_force_standard_qty_input && $( '[name="quantity_pq_dropdown"]' ).length );
		const do_timer       = ( ! is_pq_dropdown && ! options.is_sticky_add_to_cart );
		const selector       = ( is_pq_dropdown ? '[name="quantity_pq_dropdown"]' : '.m-woocommerce-product-single-input-main' );


		// Update on init
		display( $( selector ).val() );

		// Update on change
		if ( do_timer ) {
			// E.g., standard qty input
			$( selector ).on( 'input change', function () {
				display( $( selector ).val() );
				// clearTimeout( input_timer );

				// input_timer = setTimeout( function () {
					
				// }, input_timer_interval_ms );
			} );
		}
	}

	run();

	/**
	 *	Add to Cart
	 */
	const $ajaxButton = $('a.ajax_add_to_cart');
	const $submitButton = $('button.single_add_to_cart_button');
	const $quantityInput = $('.m-woocommerce-product-single-input-main');
	$ajaxButton.attr('product_id', $submitButton.val());
	$quantityInput.change(function(event) {
		const value = $(this).val();

		$ajaxButton.attr('data-quantity', value);
	});

	$('.m-woocommerce-product-single-footer .cart').submit(function(event) {
		const $this = $(this);
		$ajaxButton.trigger('click');

		event.preventDefault();
	});

	/**
	 *	Grouped Products
	 */
	const $groupedForm = $('.cart.grouped_form');
	let groupedFormBlocked = false;

	console.log($groupedForm);

	// Add to Cart
	$groupedForm.submit(function(event) {
		const $quantityInputs = $groupedForm.find('.woocommerce-grouped-product-list-item input');
		const quantityValue = $('.m-woocommerce-product-single-input-main').val();
		$quantityInputs.val(quantityValue);

		const formData = $(this).serialize();
		if (!groupedFormBlocked) {
			groupedFormBlocked = true;

			$.ajax({
				url: merchupSettings.ajaxUrl,
				type: 'POST',
				data: formData,
			})
			.done(function( response ) {
				if ( response.success ) {
					$(document.body).trigger('wc_fragment_refresh');

					setTimeout(function() {
						$(document.body).trigger('added_to_cart');
					}, 500);
				}
			})
			.always(function() {
				groupedFormBlocked = false;
			});
		}

		event.preventDefault();
	});
});
